import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

const useAtScrollPosition = desiredPosition => {
  const [atPosition, setAtPosition] = useState(false);

  const scrollCallback = debounce(() => {
    setAtPosition(window.scrollY >= desiredPosition);
  }, 200);

  useEffect(() => {
    window.addEventListener('scroll', scrollCallback);
    scrollCallback();

    return () => {
      window.removeEventListener('scroll', scrollCallback);
    };
  });

  return atPosition;
};

export default useAtScrollPosition;
